import { render, staticRenderFns } from "./Compensation.vue?vue&type=template&id=cae98d7c&scoped=true&"
import script from "./Compensation.vue?vue&type=script&lang=js&"
export * from "./Compensation.vue?vue&type=script&lang=js&"
import style0 from "./Compensation.vue?vue&type=style&index=0&id=cae98d7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae98d7c",
  null
  
)

export default component.exports